import React, {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {Container, Row, Col, Card, Button, Table} from "react-bootstrap";
import "./PersonalRegistration.css";

const FestivalRegistrationSuccess = () => {
  const {state} = useLocation();
  const {Name, Email} = state || {};

  useEffect(() => {
    window.scrollTo(0, 0); // 페이지 이동시 스크롤 맨 위로
  }, []);

  return (
    <Container className="container-full" style={{height: "100%"}}>
      <Row className="justify-content-md-start">
        <Col>
          <Card className="card border-primary mb-3">
            <Card.Header as="h4" className="card-header">
              초코파이썬 코딩 타자대회 등록되었습니다.
              3시30분에 소무대에서 만나요!
            </Card.Header>
            <Card.Body className="card-body text-primary">
              <Table striped bordered hover>
                <tbody>
                  <tr>
                    <th className="card-title">이름</th>
                    <th className="card-title">이메일</th>
                  </tr>
                  <tr>
                    <td className="card-text">{Name}</td>
                    <td className="card-text">{Email}</td>
                  </tr>
                </tbody>
              </Table>
              <div className="text-center mt-4">
                <Button variant="primary" href="/festivalRegistration" className="me-2">
                  등록 종료
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default FestivalRegistrationSuccess;
